import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'arraymap' })
export class ArrayMapPipe implements PipeTransform {
  constructor(){}
  transform (input: any[], key: string): any {
    return input.map(value => value[key]);
  }
}
